import { Action } from '@ngrx/store';
import { MsisdnProcedureInterface } from '../../models/msisdn-procedure.interface';
import { LineInterface } from '../../models/line.interface';

export enum EMsisdnProceduresActions {
  GetMsisdnProcedures = '[MSISDN_PROCEDURES] Get msisdn procedures',
  GetMsisdnProceduresSuccess = '[MSISDN_PROCEDURES] Get msisdn procedures success',
  GetMsisdnProceduresFailure = '[MSISDN_PROCEDURES] Get msisdn procedures failure'
}

export class GetMsisdnProcedures implements Action {
  public readonly type = EMsisdnProceduresActions.GetMsisdnProcedures;
  constructor(public line: LineInterface) {}
}

export class GetMsisdnProceduresSuccess implements Action {
  public readonly type = EMsisdnProceduresActions.GetMsisdnProceduresSuccess;
  constructor(public payload: Array<MsisdnProcedureInterface>) {}
}

export class GetMsisdnProceduresFailure implements Action {
  public readonly type = EMsisdnProceduresActions.GetMsisdnProceduresFailure;
}

export type MsisdnProceduresActions = GetMsisdnProcedures | GetMsisdnProceduresSuccess | GetMsisdnProceduresFailure;
